<template>
  <b-container>
    <b-form @submit.prevent="onSubmit">
      <b-checkbox
        v-model="user.enabled"
        :disabled="busy"
        :style="user.enabled ? 'color: green' : 'color: red'"
        class="mb-4 font-weight-bold"
        >{{ user.enabled ? 'Enabled' : 'Disabled' }}
      </b-checkbox>

      <b-row class="my-1">
        <b-col sm="3">
          <label class="font-weight-bold" for="fake_email">Email:</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            id="fake_email"
            v-model="user.fake_email"
            :disabled="busy || !user.enabled"
            class="mb-2"
            required
            type="email"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="3">
          <label class="font-weight-bold" for="fake_first_name">First Name:</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            id="fake_first_name"
            v-model="user.fake_first_name"
            :disabled="busy || !user.enabled"
            class="mb-2"
            required
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="3">
          <label class="font-weight-bold" for="lastName">Last Name:</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            id="lastName"
            v-model="user.fake_last_name"
            :disabled="busy || !user.enabled"
            class="mb-2"
            required
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="3">
          <label class="font-weight-bold" for="exostarId">Exostar ID:</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            id="exostarId"
            v-model="user.fake_exostarId"
            :disabled="busy || !user.enabled"
            class="mb-2"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="3">
          <label class="font-weight-bold" for="fake_guid">GUID:</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            id="fake_guid"
            v-model="user.fake_guid"
            :disabled="busy || !user.enabled"
            class="mb-2"
          ></b-form-input>
        </b-col>
      </b-row>

      <div class="text-right">
        <b-button :disabled="busy" class="mb-2 mt-4" pill type="submit" variant="primary"
          >Update
          <div v-if="busy" style="display: inline">
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </div>
        </b-button>
      </div>
    </b-form>
  </b-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ManageUserImpersonation',
    data() {
      return {
        busy: false,
        user: {
          enabled: false,
          fake_email: '',
          fake_first_name: '',
          fake_last_name: '',
          fake_exostarId: null,
          fake_guid: null,
        },
      };
    },
    computed: {
      ...mapGetters(['userForm']),
    },
    created() {
      this.getImpersonatedUser();
    },
    methods: {
      async getImpersonatedUser() {
        this.busy = true;
        await axios
          .get(`/api/users/impersonation/show/${this.userForm.email}`)
          .then(results => {
            this.user = results.data.user;
          })
          .catch(error => {
            console.error(error);
          });
        this.busy = false;
      },
      onSubmit() {
        this.busy = true;
        if (!this.checkGuidOrExostarId()) {
          this.sendToLaravel();
        } else {
          this.$bvToast.toast('Please enter either an Exostar ID or a GUID', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            appendToast: true,
            autoHideDelay: 5000,
          });
          this.busy = false;
        }
      },
      checkGuidOrExostarId() {
        return (
          (this.user.fake_exostarId == null || this.user.fake_exostarId === '') &&
          (this.user.fake_guid == null || this.user.fake_guid === '')
        );
      },
      async sendToLaravel() {
        this.user['real_email'] = this.userForm.email;
        await axios
          .post('/api/users/impersonation/create', this.user)
          .then(response => {
            this.$bvToast.toast(`User updated`, {
              title: 'Success',
              variant: 'success',
              solid: true,
              appendToast: true,
              autoHideDelay: 5000,
            });
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'Error',
              variant: 'danger',
              solid: true,
              appendToast: true,
              autoHideDelay: 5000,
            });
            console.error(error);
          });
        this.busy = false;
      },
    },
  };
</script>
